import Subject from 'common/src/utils/pubsub/subject';
import {CollaboratorsSubjectParams} from '../../collaboration/collaboration.types';

const collaborationSubjects: Record<string, Subject<CollaboratorsSubjectParams>> = {};

export {collaborationSubjects};
